import {endpoint} from '~/api';
import {ID} from '~/lib/model';
import {ISupplyPackage} from '~/modules/Pmp/models/SupplyPackage';
import {IDeal} from '~/modules/Pmp/models/Deal';

const normalizeId = (value: any): number | null => {
    if (typeof value === 'number') return value;
    if (value && typeof value === 'object' && 'value' in value) {
        const numeric = Number(value.value);
        return Number.isNaN(numeric) ? null : numeric;
    }
    return null;
};

export const fetchSupplyPackage = (id: string) => endpoint.get<ISupplyPackage>(`/pmp/packages/${id}`).then(response => response.data);
export const fetchSupplyPackages = () => endpoint.get<ISupplyPackage[]>('/pmp/packages').then(r => r.data);
export const createSupplyPackage = (supplyPackage: ISupplyPackage) => endpoint.post<ISupplyPackage>('/pmp/packages', supplyPackage).then(r => r.data);
export const updateSupplyPackage = (supplyPackage: ISupplyPackage) => endpoint.put<ISupplyPackage>(`/pmp/packages/${supplyPackage.id}`, supplyPackage).then(r => r.data);
export const deleteSupplyPackage = (id: ID) => endpoint.delete(`/pmp/packages/${id}`);

export const fetchDeal = (id: string) => endpoint.get<IDeal>(`/pmp/deals/${id}`).then(response => response.data);
export const fetchDeals = () => endpoint.get<IDeal[]>('/pmp/deals').then(r => r.data);
export const createDeal = (deal: IDeal) => endpoint.post<IDeal>('/pmp/deals', deal).then(r => r.data);
export const updateDeal = (deal: IDeal) => endpoint.put<IDeal>(`/pmp/deals/${deal.id}`, {
    ...deal,
    supplyPackageId: {value: normalizeId(deal.supplyPackageId) ?? 0}
}).then(r => r.data);
export const deleteDeal = (id: ID) => endpoint.delete(`/pmp/deals/${id}`);
